import React from 'react'
import { t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'

export const DeleteDepartmentModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <DeleteResourceModal
    alert={t`You are deleting a Department.`}
    message={t`Are you sure you want to delete this Department?`}
    title={t`Delete Department`}
    {...{ onCancel, onClose, onConfirm, isOpen }}
  />
)
